import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CreditorsServiceService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/Creditorswithinoneyear/';
  apiUrl1 = this.ConfigService.getAPIBaseUrl() + 'api/Creditorsmorethanoneyear/';

  insertcredators(data:any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Insertoneyear', data)
  }

  getcredators(id) {
    debugger
    return this.http.get(this.apiUrl + 'getoneyear?id='+id)
  }
  getlastcredators(id) {
    debugger
    return this.http.get(this.apiUrl + 'getoneyearLY?id=' + id)
  }

  insertmorecred(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl1 + 'Insertmorethanyear', data)
  }

  getmorecredators(id) {
    debugger
    return this.http.get(this.apiUrl1 + 'getmorethanyear?id='+id)
  }
  getmorecredatorsLY(id) {
    debugger
    return this.http.get(this.apiUrl1 + 'getmorethanyearLY?id=' + id)
  }
}
